export type Locale = {
  id: number;
  locale: string;
  language: string;
  label: string;
};

/**
 * Locales the apps can be displayed in. The first entry is the default.
 *
 * Lives here rather than in an app because both the OEM app and the customer
 * portal read it — the portal's profile settings offers the list, and oem's
 * LanguageProvider resolves the message bundle from the selection.
 */
const LOCALES: Locale[] = [
  {
    id: 1,
    locale: "en-US",
    language: "en",
    label: "English",
  },
  {
    id: 2,
    locale: "de-DE",
    language: "de",
    label: "German",
  },
  {
    id: 3,
    locale: "es-ES",
    language: "es",
    label: "Spanish",
  },
  {
    id: 4,
    locale: "it-IT",
    language: "it",
    label: "Italian",
  },
  {
    id: 5,
    locale: "nl-NL",
    language: "nl",
    label: "Dutch",
  },
];

export default LOCALES;
